export const DEFAULT_TOTAL_LIMIT = 20;

export const CURRENCY_RATE_ZL = 6;
export const CURRENCY_RATE_CZK = 1.2;
export const CURRENCY_RATE_EUR = 28;

export const USER_IDS_WITH_FULL_ACCESS = [
  '1hNUbGWDIlfdeXIS3mulDNZ8nf62'
]

export const HIDDEN_ROUTES = [
  'chernivtsi_jeleniaGora',
  'jeleniaGora_chernivtsi'
]

export const ALIMAN_ROUTES = [
  "chernivtsi_plzen",
  "plzen_chernivtsi",
]

export const MODULTRANS_ROUTES = [
  "chernivtsi_wroclaw",
  "wroclaw_chernivtsi",
]

export const ADMIN_USER_ROLE = "admin"
export const DEVELOPER_USER_ROLE = "developer"
export const DISPATCHER_USER_ROLE = "dispatcher"
export const PARTNER_USER_ROLE = "partner"
export const DRIVER_USER_ROLE = "driver"
export const LIMITED_DISPATCHER_USER_ROLE = "limitedDispatcher"
export const CARRIER_USER_ROLE = "carrier"
export const ALIMAN_DISPATCHER_USER_ROLE = "alimanDispatcher"

export const MODULTRANS_USER_ID = "h69gQeYzdXfo2Nxrt0luPnY8USi2"


// WEBPACK FOOTER //
// ./src/constants/config.js